import React, { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import { Box, Snackbar, Alert } from '@mui/material';
import { connect } from 'react-redux'
import routes from "@modules/routes";
import { setAlert } from '@modules/redux/actions'
import { useWallet } from '@utils/walletHelper';
import './App.scss';
import '@styles/global.scss';

const router = createBrowserRouter(routes);

const App = ({ alert, setAlert }) => {
  const { error } = useWallet()

  useEffect(() => {
    if (error !== null) {
      setAlert({
        open: true,
        message: error,
        severity: 'warning',
      })
    }
  }, [error, setAlert])

  return (
    <Box className="App">
      <RouterProvider router={router} />
      <Snackbar
        open={alert.open}
        autoHideDuration={6000}
        onClose={() => setAlert({ ...alert, open: false })}
      >
        <Alert
          onClose={() => setAlert({ ...alert, open: false })}
          severity={alert.severity}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

const mapStateToProps = ({ global }) => ({
  alert: global.alert
});

const mapToDispatchProps = (dispatch) => ({
  setAlert: (alert) => dispatch(setAlert(alert))
});

export default connect(mapStateToProps, mapToDispatchProps)(App);